import { NotifyHelper } from "../../../helpers/toast";
import { eHeActionTypeDefine } from "../../action-types/category/IHeActionType";
import { generateActionForKey, generateActions } from "../generateActions";

export const heActions = {
    ...generateActions(eHeActionTypeDefine, "HE"),
    ...generateActionForKey(eHeActionTypeDefine, "HE", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eHeActionTypeDefine, "HE", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eHeActionTypeDefine, "HE", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eHeActionTypeDefine, "HE", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eHeActionTypeDefine, "HE", "LOAD_ERROR", (m) => { NotifyHelper.Error(m) }),
};
